import { render, staticRenderFns } from "./TableClose.vue?vue&type=template&id=9120b18c&scoped=true&"
import script from "./TableClose.vue?vue&type=script&lang=js&"
export * from "./TableClose.vue?vue&type=script&lang=js&"
import style0 from "./TableClose.vue?vue&type=style&index=0&id=9120b18c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9120b18c",
  null
  
)

export default component.exports